import { render, staticRenderFns } from "./Scanner.vue?vue&type=template&id=64d3dda1"
import script from "./Scanner.vue?vue&type=script&lang=js"
export * from "./Scanner.vue?vue&type=script&lang=js"
import style0 from "./Scanner.vue?vue&type=style&index=0&id=64d3dda1&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports